import { createClient } from 'laboratory-lib';
import PortalIdParser from 'PortalIdParser';
import experiments from '../../experiments.yaml';
export const LABORATORY_CLIENT_NAME = 'ui-addon-upgrades-laboratory-client';
export const laboratoryClient = createClient({
  name: LABORATORY_CLIENT_NAME,
  experiments: experiments,
  identifiers: {
    portalId: PortalIdParser.get()
  }
});